import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetMainDealersQueryParams {}

export const getMainDealers = async (
  props: QueryProps<GetMainDealersQueryParams>
): Promise<NewUser[]> => {
  const res = await api.client.get("/dealers-new", {
    signal: props.signal,
  });
  return res.data;
};
